// @ts-nocheck








import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { fetchRequest } from './index';

export const convertDataToServer = (
tireCalculation) => (
{
  ...tireCalculation,
  sum: convertFromRubToKop(tireCalculation.sum),
  months: tireCalculation.months.map(convertDataToServerMonth)
});

export const convertDataFromServer = (
tireCalculation) => (
{
  ...tireCalculation,
  sum: convertFromKopToRub(tireCalculation.sum),
  months: tireCalculation.months.map(convertDataFromServerMonth)
});

export const convertDataToServerMonth = (
tireCalculationMonth) => (
{
  ...tireCalculationMonth,
  cost: convertFromRubToKop(tireCalculationMonth.cost)
});

export const convertDataFromServerMonth = (
tireCalculationMonth) => (
{
  ...tireCalculationMonth,
  cost: convertFromKopToRub(tireCalculationMonth.cost)
});

const basedUrl = 'tireCalculation';
const tireCalculation = new CommonApi(
  basedUrl,
  'расчет автошин',
  convertDataToServer,
  convertDataFromServer
);

const calculate = async (vehiclePlanId) => {
  const updated = await fetchRequest.put(
    `/${basedUrl}/calculate/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось произвести расчет`);
};

const changeStatus = async (
vehiclePlanId,
status) =>
{
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, {
    vehiclePlanId,
    status
  });
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус расчет`);
};

export default {
  ...tireCalculation,
  calculate,
  changeStatus
};
